import React, { useContext, useEffect, useMemo, useState } from 'react'
import { injectIntl } from 'react-intl'
import { UserContext, NotifyContext } from 'context'
import { Card, CardIcon, CardBody, CardActions } from '../Card'
import { Loader } from 'semantic-ui-react'
import Paginator from '../Paginator'
import DriverEditModal from './DriverEditModal'

import api from '../../../actions/api'
import doRequest from 'actions/doRequest'

import { cardsOnPage } from 'constants/config.json'
import './DriversPage.css'
import DriverInfoModal from './DriverInfoModal'
import Filter from '../Filter'
import Label from '../Label'

function DriversPage (props) {
    const { intl } = props
    const { currentUser, logout } = useContext(UserContext)
    const { pushNotify } = useContext(NotifyContext)

    const [loading, setLoading] = useState(false)
    const [drivers, setDrivers] = useState([])
    const [pageCount, setPageCount] = useState(0)
    const [page, setPage] = useState(1)
    const [filter, setFilter] = useState({})
    const [isFilterActive, setIsFilterActive] = useState(false)
 
    const translates = useMemo(() => {
        return {
            driver: intl.formatMessage({ id: 'title.driver' }),
            status: intl.formatMessage({ id: 'title.status' }),
            active: intl.formatMessage({ id: 'user.active' }),
            disabled: intl.formatMessage({ id: 'user.disable' }),
            notFound: intl.formatMessage({ id: 'title.recordNotFound' }),
        }
    }, [intl.locale]) // eslint-disable-line react-hooks/exhaustive-deps

    const loadDrivers = (page) => {
        setDrivers([])
        setLoading(true)

        const offset = cardsOnPage * (page - 1), count = cardsOnPage
        const req = doRequest(api.driver.list(offset, count, filter.filFirstName, filter.filLastName, filter.filActive, filter.driversLicense ), pushNotify, logout)

        req.ready.then(({ drivers, count } ) => {
            const pages = Math.ceil(count / cardsOnPage)

            setDrivers(drivers)      
            
            if (page > pages & pages > 0) {
                loadDrivers(pages)
            } else {
                setPageCount(pages)
                setPage(page)
            }
        }).catch(console.error)
        .finally(() => {
            setLoading(false)
            const filteredFilterValues = Object.values(filter).filter(el => el !== '' && el.length !== 0)
            filteredFilterValues.length !== 0 ? setIsFilterActive(true) : setIsFilterActive(false)
        })
    }

    const refresh = () => {
        loadDrivers(page)
    }

    useEffect(() => refresh(), [filter]) // eslint-disable-line react-hooks/exhaustive-deps

    const filterList = useMemo(() => {
        return [
            {
                title: intl.formatMessage({id:"user.firstName"}),
                type: 'input',
                name: 'filFirstName'
            },
            {
                title: intl.formatMessage({id:"user.lastName"}),
                type: 'input',
                name: 'filLastName'
            },
            {
              title: intl.formatMessage({id:"user.driversLicense"}),
              type: 'input',
              name: 'driversLicense'
            },
            {
              title: intl.formatMessage({id:"user.patronymic"}),
              type: 'input',
              name: 'patronymic'
            },
            {
                title: intl.formatMessage({ id: 'title.status' }),
                type: 'dropdown',
                name: 'filActive',
                options: [0,1].map(item => ({ key: item, text: intl.formatMessage({ id: item === 1 ? 'user.active' : 'user.disable' }), value: item }))
            }
        ]
    }, [intl]) 

    return (
        <React.Fragment>
            { loading ? 
                <Loader className={"page-loader"} active inline="centered" />
            :
                <React.Fragment>
                    <div className="topPanel">
                        <Filter filter={filter} disabled={loading} setFilter={e => { setFilter(e) }} filterList={filterList} isFilterActive={isFilterActive} className="modalMaxWidth" />
                    </div>
                    <DriverEditModal type="add" onEditUsers={refresh} />
                    {
                    drivers.length === 0 ?    
                    <Label text={translates.notFound} />
                    :
                    drivers.map((driver) => (
                        <Card key={driver.id} className="infoCard">
                            <CardIcon name="user circle" />
                            <CardBody>
                                <span><b>{translates.driver}:</b> {driver.firstName} {driver.lastName}</span>
                                <span><b>{translates.status}:</b> {driver.active ? translates.active : translates.disabled}</span>
                            </CardBody>
                            <CardActions>
                                <DriverEditModal id={driver.id} type="edit" onEditUsers={refresh} />
                                {currentUser.role===1&&<DriverInfoModal id={driver.id} intl={intl} logout={logout} pushNotify={pushNotify} />}
                            </CardActions>
                        </Card>
                    ))}
                </React.Fragment>
            }
            <Paginator pageCount={pageCount} page={page} setPage={loadDrivers} disabled={loading} />
        </React.Fragment>
    )
}

export default injectIntl(DriversPage)
